import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const brands = [
  { name: 'RICOH', img: 'richo.png' },
  { name: 'Konica Minolta', img: 'Konica-Minolta.png' },
  { name: 'Sharp', img: 'Sharp.png' },
  { name: 'Toshiba', img: 'Toshiba.png' },
  { name: 'HP', img: 'HP.png' },
  { name: 'Canon', img: 'Canon.png' },
  { name: 'Epson', img: 'Epson.png' },
  { name: 'EZOFIS', img: 'EZOFIS.png' },
  { name: 'PaperCut', img: 'pappercut.png' },
  { name: 'MyQ', img: 'myq.png' },
];

export default function Partners() {
  const { t } = useLanguage();
  return (
    <div className="partners-strip">
      <p>{t.partners.title}</p>
      <div className="partners-carousel">
        <div className="partners-track">
          {[...brands, ...brands].map((b, i) => (
            <div className="brand-tile" key={`${b.name}-${i}`}>
              <img src={`${process.env.PUBLIC_URL}/Assets/brand/${b.img}`} alt={b.name} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
